export default __webpack_public_path__ + "static/media/partner-sm.06b7ad03.png";